import { useResetContactStepsOnAutomationTemplateChange } from '../../../queries/Automation';

export function AutomationContactStepsCacheReset(): null {
	useResetContactStepsOnAutomationTemplateChange();
	return null;
}
